import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { getJobsBoardLayout } from '@layouts/JobsBoardLayout';
import { NextPageWithLayout } from '@lib/utils/pageHelper';

import InviteIndex from './jobs/AvailChecks';

const Index: NextPageWithLayout = () => {
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) router.replace('/jobs/AvailChecks');
  }, [router]);
  return <InviteIndex />;
};

Index.getLayout = getJobsBoardLayout;

export default Index;
